function isGradientStopType(item) {
  return item.offset != null && typeof item.offset === 'number' && item.color != null && typeof item.color === 'string';
}

function isGradientType(color) {
  return Array.isArray(color) && color.every(item => isGradientStopType(item));
}

export { isGradientType };
